import {useTheme} from "@emotion/react";
import {Form} from "@remix-run/react";
import {forwardRef} from "react";
import SectionWrapper from "../../layouts/SectionWrapper/index.jsx";
import {AdStickyWrapper, AdWrapper} from "./style.js";

export const BASE_AD_TAG = {
  "728*90": "via_b2_728x90_magazine",
  "2*728*90": "via_b3_728x90_magazine",
  "970*250": "via_g1_970x250_magazine",
  "300*250": "via_r1_300x250_magazine",
  "2*300*250": "via_r2_300x250_magazine",
  stickyMobile: "via_j1_1x1_magazine",
  card: "via_j1_1x1_magazine",
};
export const AD_TAGS = Array.from(new Set(Object.values(BASE_AD_TAG)));
export const sectionAd = [
  "via_b2_728x90_magazine",
  "via_g1_970x250_magazine",
  "via_b3_728x90_magazine",
];
export const AVAILABLE_ADS = {
  homepage: [
    "via_g1_970x250_magazine",
    "via_b2_728x90_magazine",
    "via_r1_300x250_magazine",
    "via_j1_1x1_magazine",
  ],
  articlePage: [
    "via_g1_970x250_magazine",
    "via_b2_728x90_magazine",
    "via_b3_728x90_magazine",
    "via_r1_300x250_magazine",
    "via_j1_1x1_magazine",
  ],
  destinationPage: [
    "via_b3_728x90_magazine",
    "via_g1_970x250_magazine",
    "via_b2_728x90_magazine",
    "via_r1_300x250_magazine",
    "via_j1_1x1_magazine",
  ],
  pages: [
    "via_g1_970x250_magazine",
    "via_b2_728x90_magazine",
    "via_r1_300x250_magazine",
    "via_j1_1x1_magazine",
  ],
};
export const BASE_PAGE_AD_ID = "via_magazine";

export const LongAd = ({tag, styles}) => {
  return (
    <AdWrapper grid={"2/16"}>
      <div
        id={tag}
        style={{
          gridColumn: "3/15",
          aspectRatio: "1000/90",
          maxWidth: 1000,
          width: "100%",
          ...styles,
        }}
      />
    </AdWrapper>
  );
};

export const HighAd = ({styles}) => {
  return (
    <AdWrapper grid={"3/15"}>
      <div
        id={BASE_AD_TAG["970*250"]}
        style={{
          aspectRatio: "970/250",
          width: "100%",
          maxWidth: 970,
          ...styles,
        }}
      />
    </AdWrapper>
  );
};
export const ShortAd = ({tag, styles}) => {
  return (
    <AdWrapper grid={"3/15"}>
      <div
        id={tag}
        style={{
          gridColumn: "4/14",
          aspectRatio: "728/90",
          maxWidth: 728,
          width: "100%",
          ...styles,
        }}
      />
    </AdWrapper>
  );
};

export const ADS = {
  "1000*90": LongAd,
  "970*250": HighAd,
  "728*90": ShortAd,
};

export const Ad = ({showAd = false, type, styles, bgColor = "white", tag}) => {
  const {breakpoints} = useTheme();
  const {isMobile, md} = breakpoints;
  const AdComponent = ADS[type];
  return (
    !md &&
    showAd && (
      <SectionWrapper backgroundColor={bgColor}>
        {!!AdComponent && <AdComponent tag={tag} styles={{marginBlock: 60, ...styles}} />}
      </SectionWrapper>
    )
  );
};
export const AdMobileSticky = ({showAd = true}) => {
  const {breakpoints} = useTheme();
  const {md} = breakpoints;
  return (
    md &&
    showAd && (
      <Form navigate={false} method="post">
        <AdStickyWrapper type={"submit"} name={"_action"} value={"mobileAd"}>
          <div style={{width: "100%", height: "100%"}} id={BASE_AD_TAG.stickyMobile} />
        </AdStickyWrapper>
      </Form>
    )
  );
};

export const B10Ad = forwardRef(({tag}, ref) => {
  return (
    <div
      id={tag}
      ref={ref}
      style={{
        gridColumn: "13/17",
        margin: "auto 0px",
        maxWidth: "300px",
        aspectRatio: "300/250",
      }}
    />
  );
});
